import { useEffect, useRef, useState } from "react";
import { Button } from "../../ui/button";
import { cn } from "@/lib/utils";
import { HeaderWithFilterProps } from "../types/header-with-filter-props.type";
import { ChevronUp, XIcon } from "lucide-react";
import { MultipleFilter } from "./MultipleFilter";
import { SingleFilter } from "@/components/data-table/filters/SingleFilter";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const FilterField = ({ selected, onChangePage, item, label }: HeaderWithFilterProps) => {
  const selectedValues = selected || [];
  const [open, setOpen] = useState(false);
  const [triggerWidth, setTriggerWidth] = useState<number>(0);
  const triggerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (triggerRef.current) {
      setTriggerWidth(triggerRef.current.offsetWidth);
    }
  }, [open, selectedValues.length, label]);

  return (
    <div
      className="flex border border-color-icon rounded-xl items-center overflow-hidden group hover:bg-accent"
      ref={triggerRef}
    >
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button variant="ghost" className="gap-[7px] rounded-none group-hover:bg-accent">
            <span className="font-semibold text-trend-neutral text-sm">{label}</span>
            <span className="size-5.5 bg-[#E8E8E84D] group-hover:bg-white rounded-[6px] font-black text-[9x] transition-colors">
              {selectedValues.length}
            </span>
            <span className="font-semibold text-chart-title text-sm">Sélectionné</span>
            <ChevronUp className={cn("transform transition duration-150", open ? "rotate-180" : "")} />
          </Button>
        </PopoverTrigger>
        <PopoverContent
          align="start"
          className="space-y-2"
          style={{ width: triggerWidth > 0 ? `${triggerWidth}px` : "auto" }}
        >
          {item.multi ? (
            <MultipleFilter item={item} onChangePage={onChangePage} selected={selectedValues} />
          ) : (
            <SingleFilter item={item} onChangePage={onChangePage} selected={selectedValues} setOpen={setOpen} />
          )}
        </PopoverContent>
      </Popover>
      {selectedValues.length ? (
        <Button variant="ghost" onClick={() => onChangePage([])} className="rounded-none group-hover:bg-accent">
          <XIcon className="size-4 cursor-pointer" />
        </Button>
      ) : null}
    </div>
  );
};
